import ApiClient from '@/api/ApiClient';

import type {
  AbsenceProfile,
} from '../models';

export class AbsenceProfileResourceClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getProfiles(): Promise<AbsenceProfile[]> {
    return this.apiClient.get({
      path: '/api/absences/profiles',
    });
  }

  putProfile(request: { body?: AbsenceProfile; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/absences/profiles',
      body,
    });
  }

  deleteProfile(request: { id: string; }): Promise<void> {
    const { id } = request;
    return this.apiClient.del({
      path: `/api/absences/profiles/${id}`,
    });
  }

  getProfileByName(request: { name: string; }): Promise<AbsenceProfile[]> {
    const { name } = request;
    return this.apiClient.get({
      path: `/api/absences/profiles/${name}`,
    });
  }
}

export default AbsenceProfileResourceClient;
